import './workout.css';
import React, {useEffect, useRef} from "react";
import {useNavigate} from "react-router-dom";
import Routes from "../../assets/RoutesToPages/Routes";
import {ReactComponent as AvocadoMorning} from './img-workout/avocadoes/avocado-morning.svg';
import {ReactComponent as AvocadoHips} from './img-workout/avocadoes/avocado-hips.svg';
import {ReactComponent as AvocadoBurn} from './img-workout/avocadoes/avocado-burn.svg';
import {ReactComponent as AvocadoFullBody} from './img-workout/avocadoes/avocado-full-body.svg';
import {ReactComponent as AvocadoToned} from './img-workout/avocadoes/avocado-toned-arms.svg';
import {ReactComponent as AvocadoMaximumWeight} from './img-workout/avocadoes/avocado-maximum-weight-loss.svg';
import {ReactComponent as WorkoutContentLogo} from './img-workout/main-img.svg';
import {ReactComponent as WorkoutPageNavigationArrow} from './img-workout/back_arrow.svg';
import {ReactComponent as WorkoutPageNavigationCalendar} from './img-workout/calendar-icon.svg';


const workoutContent = [
  {
    id: 1,
    image: AvocadoMorning,
    title: 'Morning Routine',
    subtitle: 'Wake up energized by doing these exercises every morning',
    dataTitle: "Morning Routine",
  },
  {
    id: 2,
    image: AvocadoHips,
    title: 'Hips, Butt and Thighs',
    subtitle: 'Make yourself stronger, faster, and more enduring',
    dataTitle: "Hips, Butt and Thighs",
  },
  {
    id: 3,
    image: AvocadoBurn,
    title: 'Burn Belly Fat',
    subtitle: 'Belly fat burning is a great way to see results quickly',
    dataTitle: "Burn Belly Fat",
  },
  {
    id: 4,
    image: AvocadoFullBody,
    title: 'Full-Body Workout',
    subtitle: 'Start your body-toning routine now!',
    dataTitle: "Full-Body Workout",
  },
  {
    id: 5,
    image: AvocadoToned,
    title: 'Toned Arms and Chest',
    subtitle: 'Work out your chest muscles, biceps and triceps.',
    dataTitle: "Toned Arms and Chest",
  },
  {
    id: 6,
    image: AvocadoMaximumWeight,
    title: 'Maximum Weight Loss',
    subtitle: 'Exercises set to burn the most calories.',
    dataTitle: "Maximum Weight Loss",
  },
]

const WorkoutPage = () => {
  const navigate = useNavigate();
  const userWorkoutRef = useRef(null);
  const timerFadeIn = useRef(null);


  useEffect(() => {
    if (userWorkoutRef.current) {
      userWorkoutRef.current.classList.add('user-workout-fade-in');
    }

    timerFadeIn.current = setTimeout(() => {
      userWorkoutRef.current.classList.remove('user-workout-fade-in');
    }, 350)

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, []);


  const handleChooseExercise = (dataTitle, title) => () => {
    navigate(Routes.workoutSetupPage, {
      state: {
        dataTitle: dataTitle,
        title: title,
      },
    });
  }


  return (
    <div ref={userWorkoutRef}
         className='workout-container'>
      <p className='workout-container__title'>Workout</p>
      <div className='workout-content'>
        <WorkoutContentLogo className="workout-content-logo"
                            width='131'
                            height='134'/>
        <div className='workout-page-navigation'>
          <WorkoutPageNavigationArrow className='workout-page-navigation__arrow'
                                      onClick={() => navigate(-1)}
                                      width='24'
                                      height='24'>
          </WorkoutPageNavigationArrow>
          <WorkoutPageNavigationCalendar className='workout-page-navigation__calendar'
                                         onClick={() => navigate(Routes.calendarPage)}
                                         width='24'
                                         height='24'>
          </WorkoutPageNavigationCalendar>
        </div>
        <div className='workout-exercise-container'>
          {workoutContent.map(exerciseType => {
            const SvgIcon = exerciseType.image;
            return (
              <div key={exerciseType.id}
                   onClick={handleChooseExercise(exerciseType.dataTitle, exerciseType.title)}
                   className='workout-exercise'>
                <div className='img-exercise-container'>
                  <SvgIcon className={`img-exercise img-exercise-${exerciseType.id}`}/>
                </div>
                <div className='workout-exercise__description'>
                  <p className='workout-exercise__title'>{exerciseType.title}</p>
                  <p className='workout-exercise__subtitle'>{exerciseType.subtitle}</p>
                </div>
              </div>);
          })}
        </div>
      </div>
    </div>
  )
}

export default WorkoutPage;